<template>
  <!--62知识中心开始-->
  <div @contextmenu.stop.prevent="handleContextmenu"
       @touchstart="touchstarts()"
       @touchmove="touchmoves()"
       @touchend="touchends()">
    <div id="knowledge62"
         :class="[centerStyle]">
      <!-- 区块标题 -->
      <tit :title="blockData.title"
           :src='rightSrc'
           @clear="clearSrc"
           :subtitle="blockData.subtitle"
           @refesh="refeshData"
           @backFn="changeFlowTab"></tit>
      <!--知识中心内容开始-->
      <div class="outreach_content"
           style="overflow:hidden;">
        <div class="block-content">
          <!-- 手机端显示按钮 -->
          <div class="btn-left"
               v-show="(floorTabShow.indexOf('left')>-1)"></div>
          <div class="btn-right"
               v-show="(floorTabShow.indexOf('right')>-1)"></div>
          <div class="close-left"
               v-show="isPC?'true':showLeftMenu"></div>
          <div class="close-right"
               v-show="isPC?'true':showRightMenu"></div>
          <!--左侧切换开始-->
          <left-tab v-show="isPC?'true':showLeftMenu"
                    v-if="(floorTabShow.indexOf('left')>-1)"
                    :Ind="leftTabInd"
                    :tabActiveType="tabActiveType"
                    :perNum="tabTopBottomLen"
                    :refeshflag="refeshflag"
                    :tempNav="preTabListLeft"
                    :nav="nodeNavLeft"
                    :blockData="blockData"
                    :navHeight="rightContentHeight"
                    @changeTab="changeFlowTab" />
          <!--左侧切换结束-->
          <!--右侧内容区开始-->
          <div class="right-content fl"
               ref='rightContent'
               :style="{width:`calc(100% - ${186*tabLeftRightLen+2}px)`}">
            <!--右侧切换一开始-->
            <div class="content-center">
              <!--顶部切换开始-->
              <top-tab v-if="(floorTabShow.indexOf('up')>-1)"
                       :Ind="leftTabInd"
                       :tabActiveType="tabActiveType"
                       :refeshflag="refeshflag"
                       :title="blockData.title"
                       :tempNav="preTabListTop"
                       :nav="nodeNavTop"
                       :flowSlideshow="blockData.flowSlideshow"
                       @changePerson="changePerson"
                       @changeTab="changeFlowTab"></top-tab>
              <!--顶部切换结束-->
              <!--主要内容开始-->
              <div v-if="!iframeSrc"
                   ref="centerEle">
                <!-- 左右多图文 -->
                <expert v-if="centerStyle=='expertsAlliance'"
                        @emitHandleDetail="handleDetail"
                        @emitContextMenuItem="leftRightMove"
                        :class="[centerStyle,'smartAppSameScreenShow']"
                        :tagsDataList="listData" />
                <!-- 多图展示 -->
                <enterpris v-else-if="centerStyle=='enterprisAlliance'"
                           @emitHandleDetail="handleDetail"
                           @emitContextMenuItem="leftRightMove"
                           :class="[centerStyle,'smartAppSameScreenShow']"
                           :tagsDataList="listData" />
                <!-- 信息列表 -->
                <news v-else-if="centerStyle=='article'"
                      @emitHandleDetail="handleDetail"
                      @emitContextMenuItem="leftRightMove"
                      :class="[centerStyle,'smartAppSameScreenShow']"
                      :tagsDataList="listData" />
                <!-- 同屏展示 -->
                <baseGroup v-else-if="centerStyle=='smartAppSameScreenShow'"
                           @emitHandleDetail="handleDetail"
                           @emitContextMenuItem="leftRightMove"
                           :centerStyle="centerStyle"
                           :preNum="preNum"
                           :swiperInd="swiperInd"
                           :standList="standardListJson" />
                <!-- 多图遮罩/标准楼层 -->
                <smartApp v-else-if="centerStyle=='smartApp'||centers == 'banner'"
                          :centerStyle='centerStyle'
                          :blockData='blockData'
                          :blockCenterList='blockCenterList'
                          :tabActiveType="tabActiveType"
                          @emitHandleDetail="handleDetail"
                          :tabLeftRightLen="tabLeftRightLen"
                          :listData="listData"
                          @emitContextMenuItem="leftRightMove"
                          ref='smartApp'
                          @emitChangeFlowTab='changeFlowTab'
                          :flowStep='flowStep'
                          :swiperInd='swiperInd' />
                <!-- 图文信息 -->
                <tradeNews v-else-if="centerStyle=='tradeNews'"
                           :centerStyle='centerStyle'
                           :blockCenterList='blockCenterList'
                           :blockData='blockData'
                           :listData="listData" />
                <!-- 多图文列表 -->
                <knowledgeCenter v-else-if="centerStyle=='knowledgeCenter'"
                                 :centerStyle='centerStyle'
                                 :blockData='blockData'
                                 @emitHandleDetail="handleDetail"
                                 @emitContextMenuItem="leftRightMove"
                                 :listData="listData"
                                 :tabLeftRightLen="tabLeftRightLen" />
                <!-- 流程架构 -->
                <baseGroupProcess v-else-if="centerStyle=='flowArchShow'"
                                  :class="['flowArchShow']"
                                  :centerStyle="centerStyle"
                                  :preNum="preNum"
                                  :swiperInd="swiperInd"
                                  :standList="standardListJson"
                                  @emitHandleDetail="handleDetail"
                                  @emitContextMenuItem="leftRightMove" />
                <!-- 单图文展示/企业简介 -->
                <qyjjContent v-else-if="centerStyle=='companyIntroduce'"
                             :blockData='blockData' />
                <!-- 线型图 -->
                <smartChart v-else-if="centerStyle=='smartChart'"
                            :blockData='blockData'
                            ref='_changeFlowTab' />
                <!-- 横向列表区块 -->
                <horizontal v-else-if="centerStyle=='leftRightImgText'"
                            @emitHandleDetail="handleDetail"
                            @emitContextMenuItem="leftRightMove"
                            :listData='listData' />
                <!-- 小区块 -->
                <smallBlock v-else-if="centerStyle=='pictureImgText'"
                            @emitHandleDetail="handleDetail"
                            @emitContextMenuItem="leftRightMove"
                            :listData='listData' />
              </div>
              <div v-if="iframeSrc"
                   class="bottom-switch">
                <!--切换一开始-->
                <iframe style="width:100%;height:100%;"
                        :src="iframeSrc"
                        frameborder="0"></iframe>
                <!--切换一结束-->
              </div>
              <!--主要内容结束-->
              <bottom-tab v-if="(floorTabShow.indexOf('down')>-1)"
                          :Ind="leftTabInd"
                          :tabActiveType="tabActiveType"
                          :refeshflag="refeshflag"
                          :perNum="tabLeftRightLen"
                          :tempNav="preTabListBottom"
                          :nav="nodeNavDown"
                          :blockData="blockData"
                          @changeTab="changeFlowTab"></bottom-tab>
            </div>
            <!--右侧切换一结束-->
          </div>
          <!--右侧内容区结束-->
          <right-tab v-show="isPC?'true':showRightMenu"
                     v-if="(floorTabShow.indexOf('right')>-1)"
                     :Ind="leftTabInd"
                     :tabActiveType="tabActiveType"
                     :perNum="tabTopBottomLen"
                     :refeshflag="refeshflag"
                     :tempNav="preTabListRight"
                     :nav="nodeNavRight"
                     :blockData="blockData"
                     :navHeight="rightContentHeight"
                     @changeTab="changeFlowTab" />
        </div>
      </div>
      <!--内容区块结束-->
    </div>

  </div>
  <!--62知识中心结束-->
</template>
<script>
import Bus from '../../bus.js'
import tit from "./control/tit.vue"
import topTab from "./control/topTab.vue"
import bottomTab from "./control/bottomTab.vue"
import leftTab from "./control/leftTab.vue"
import rightTab from "./control/rightTab.vue"
import expert from "./expert.vue"
import enterpris from "./enterpris.vue"
import news from "./news.vue"
import knowledgeCenter from "./knowledgeCenter.vue"
import baseGroup from "./baseGroup.vue"
import baseGroupProcess from "./baseGroupProcess.vue"
import ZImage from "../ZImage.vue"
import smartApp from "./smartApp.vue"
import tradeNews from "./tradeNews.vue"
import qyjjContent from "./qyjjContent.vue"
import smartChart from "./smartChart.vue"
import horizontal from "./horizontal_list.vue"
import smallBlock from "./small_block.vue"
// import centerMode from "./centerMode.vue"
export default {
  name: 'zszx',
  components: {
    tit: tit,
    topTab,
    bottomTab,
    leftTab,
    rightTab,
    expert,
    enterpris,
    ZImage,
    news,
    knowledgeCenter,
    baseGroup,
    smartApp,
    tradeNews,
    qyjjContent,
    smartChart,
    horizontal,
    smallBlock,
    baseGroupProcess
  },
  props: {
    blockData: {
      type: Object
    },
    _centerStyle: {
      require: true,
      default: ""
    },
    baseNavHeight: {
      type: Number,
      default: 425
    }
  },
  data () {
    return {
      timeOutEvent: 0,
      rightSrc: '',
      height: '',
      heights: '',
      centers: '',
      iframeSrc: '',
      showLeftMenu: false,
      showRightMenu: false,
      leftTabInd: 0,
      topTabInd: 0,
      listData: [],
      standardListJson: [],
      showList: false,
      refeshflag: false,
      tempNav: [],
      nodeNavTop: [],
      nodeNavLeft: [],
      nodeNavRight: [],
      nodeNavDown: [],
      blockId: '',
      flowId: '',
      nodeId: '',
      contentId: '',
      floorTabShow: '',
      floorDetailShow: '',
      noData: false,
      preTabListTop: [],
      preTabListLeft: [],
      preTabListRight: [],
      preTabListBottom: [],
      tabTopBottomLen: 0,
      tabLeftRightLen: 0,
      tabActiveType: 'up',
      preNum: 5,
      timer: null,
      messages: [],
      requiredMsgs: [],
      circleTabList: [],
      screenWidth: document.documentElement.clientWidth,//屏幕宽度
      canAddCircleData: true,
      candliverProp: true,
      isQuote: false,
      centerStyles: '',
      rightContentHeight: '',
      centerStyle: '',
      blockCenterList: [],
      changeFlowBlock: '',
      flowStep: ''
    }
  },
  computed: {
    isPC () {
      // if(window.innerWidth > 768 || window.innerWidth <= 425){
      if (window.innerWidth) {
        return true;
      } else { return false; }
    },
    tagData () {
      return this.$store.state.tagData;
    }
  },
  watch: {
    floorTabShow: function (tabShow) {
      var tableft = tabShow.indexOf('left') > -1;
      var tabright = tabShow.indexOf('right') > -1;

      var tabbottom = tabShow.indexOf('down') > -1;
      var tabtop = tabShow.indexOf('up') > -1;

      var preNum = 5;
      var Len = 0;
      var tbLen = 0;
      if (tableft || tabright) {
        Len = 1;
        preNum = 5;
        if (tableft && tabright) {
          Len = 2;
          preNum = 4;
        }
      }
      if (tabbottom || tabtop) {
        tbLen = 1;
        if (tabbottom && tabtop) {
          tbLen = 2;
        }
      }

      if (window.innerWidth > 425 && window.innerWidth <= 768) {
        tbLen = 0;
        Len = 0;
      }
      this.preNum = preNum;
      this.tabLeftRightLen = Len;
      this.tabTopBottomLen = tbLen
    }
    // screenWidth:function(){
    //     this.swiperFn();
    // }

  },
  mounted () {
    this.centerStyles = this._centerStyle;
    this.centerStyle = this._centerStyle;
    var _this = this
    //添加 第一个主流程tab名称
    var { id, flowType, code, appId, name, pcode, floorType } = this.blockData;
    var Mainitem = { id, flowType, code, appId, name, pcode, floorType, tabType: 'main' }
    this.blockData.dataArr.unshift(Mainitem)

    this.getTabBlock(id);
    //获取勾选优先级数据  包含流程和流程块
    // this.getCheckTabFlow(id);
    // this.getCheckTabBlock(id);
    window.addEventListener('resize', function () {
      _this.screenWidth = document.body.offsetWidth;
    });
    //监听中间块高度
    var elementResizeDetectorMaker = require("element-resize-detector")
    var erd = elementResizeDetectorMaker()
    erd.listenTo(this.$refs.rightContent, function (element) {
      _this.rightContentHeight = element.clientHeight;
    })
    //监听中心展示高度
    erd.listenTo(this.$refs.centerEle, function (element) {
      _this.heights = element.clientHeight;
    })
  },
  methods: {
    touchstarts () {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.handleContextmenu();
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmove: function () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchend: function (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    },
    //关闭中心iframe
    clearSrc () {
      this.rightSrc = '';
      this.swiperFn();
    },
    //跳转个人信息页面
    changePerson (item) {
      //通过
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowByUserId.json", {
          // appId:this.blockData.appId,
          appId: this.getQuery('appId'),
          userId: item.userId,
        }).then(res => {
          if (res.state == 1) {
            this.nodeNavTop = res.data;
          }
        })
      this.iframeSrc = 'https://cms.520emv.com/acnid-project-approve/bsys/commonchooseUser/tsyscircleuser/myInfo?userId=' + item.userId;
    },
    setTagData () {
      var tableft = this.floorTabShow.indexOf('left') > -1;
      var tabright = this.floorTabShow.indexOf('right') > -1;

      var tabbottom = (this.floorTabShow.indexOf('down') > -1);
      var tabtop = (this.floorTabShow.indexOf('up') > -1);

      var preNum = 5;
      var Len = 0;
      var tbLen = 0;
      if (tableft || tabright) {
        Len = 1;
        preNum = 4;
        if (tableft && tabright) {
          Len = 2;
          preNum = 3;
        }
      }
      if (tabbottom || tabtop) {
        tbLen = 1;
        if (tabbottom && tabtop) {
          tbLen = 2;
        }
      }

      if (window.innerWidth > 425 && window.innerWidth <= 768) {
        tbLen = 0;
        Len = 0;
      }
      this.preNum = preNum;
      this.tabLeftRightLen = Len;
      this.tabTopBottomLen = tbLen;
    },
    handleContextmenu () {
      this.$store.commit('setFlowType', this.blockData.floorType);
      window.$changeFlowBlock = this.changeFlowBlock;
      window.$floorflowId = this.blockData;
      window.$floorId = this.flowId;
      window.$nodeId = this.nodeId;
      window.$blockId = this.blockId;
      Bus.$emit('sendCircleType', { circle: this.canAddCircleData, dliverProp: this.candliverProp });
    },
    //轮播图
    swiperFn () {
      let _this = this;
      this.setTagData();
      if (_this.mySwiper && _this.mySwiper[0] !== undefined) {
        _this.mySwiper[0].destroy();
      }
      let sildeNum = this.preNum;
      if (window.innerWidth > 425 && window.innerWidth <= 768 && (this.centerStyle != 'banner' || this.centerStyle != 'companyIntroduce')) {
        // return false;
        sildeNum = 2;
      }
      // let sildeNum = 1;
      // if(this.blockData.floorSlideshow != 'on'&&!(this.centerStyle=='banner'||this.centerStyle=='companyIntroduce')){
      //     sildeNum = this.preNum;
      // }

      if (this.centerStyle == 'banner' || this.centerStyle == 'companyIntroduce') {
        sildeNum = 1;
      }
      this.$nextTick(() => {

        _this.mySwiper = new window.Swiper('.bottom-content' + this.swiperInd, {
          slidesPerView: sildeNum,
          slidesPerGroup: sildeNum,
          autoplay: (this.blockData.floorSlideshow != 'on' && (this.centerStyle != 'banner' || this.centerStyle != 'companyIntroduce')) ? false : true,
          spaceBetween: 20,
          navigation: {
            nextEl: '.arrow-right' + this.swiperInd,
            prevEl: '.arrow-left' + this.swiperInd,
          }
        })

        // mySwiper.navigation.update();
      })
    },
    //左移右移
    leftRightMove (ind, ev) {
      this.handleContextmenu();
      this.$store.commit('setFlowType', this.blockData.floorType);
      if (this.blockId) {
        window.$blockId = this.blockId;
      }
      const item = this.standardListJson[ind];
      window.$nodeId = item.nodeId;
      Bus.$emit('windowRight', ev, item);
      var left = {}, center = {}, right = {};
      if (ind > 0) {
        var leftItem = this.standardListJson[ind - 1];
        if (leftItem && leftItem.contentId) {
          left = {
            blockId: leftItem.blockId,
            contentId: leftItem.contentId,
            contentShowRowsSort: leftItem.contentShowRowsSort
          };
        }
      }
      if (ind < this.standardListJson.length) {
        var rightItem = this.standardListJson[ind + 1];
        if (rightItem && rightItem.contentId) {
          right = {
            blockId: rightItem.blockId,
            contentId: rightItem.contentId,
            contentShowRowsSort: rightItem.contentShowRowsSort
          };
        }
      }
      if (item && item.contentId) {
        center = {
          item: item,
          blockId: item.blockId,
          contentId: item.contentId,
          contentShowRowsSort: ind,
          standardJson: item.standardJson
        }
      }
      var rightLeft = {
        left: left,
        center: center,
        right: right
      }
      window.$rightLeft = rightLeft;
    },
    //获取左右上下
    getTabBlock (id) {
      this.floorTabShow = ''
      var _this = this;
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/getShowFlowPosition.json", {
          // appId:this.blockData.appId,
          appId: this.getQuery('appId'),
          flowId: id,
          flowOrDetail: 'flow',
          domainNameType: document.location.pathname.split('/')[1]
        }).then(res => {
          if (res.state == 1) {
            this.floorTabShow = res.data ? res.data : 'up';
          }
          this.floorTabShow = res.data ? res.data : 'up';
          return this.$blockGetData.getActiveType(this.floorTabShow);

        }).then((tablist) => {
          //根据 返回勾选进行中间块标签块请求 
          // 1. 标准楼层中间块暂时 不能进行标签请求
          // 2. 数据请求按照中间、上、左、右、下勾选顺序进行请求
          // 3. 当无数据使用空数据进行填充

          tablist.map((tab) => {
            _this.getSelectTabFlowAndBlock(id, tab, tablist[0]);
          })

        })

      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/getShowFlowPosition.json", {
          // appId:_this.blockData.appId,
          appId: _this.getQuery('appId'),
          flowId: id,
          flowOrDetail: 'detail',
          domainNameType: document.location.pathname.split('/')[1]
        }).then(res => {
          _this.floorDetailShow = res.data ? res.data : 'down'
        })

    },
    getSelectTabFlowAndBlock (fId, tab, firstTab) {
      const _this = this;
      const tabtype = this.getMapValuesByFloorTabType(tab);
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getMainTopNavList.json", {
          appId: _this.getQuery('appId'),
          types: tabtype,
          flowId: fId
        }).then(res => {
          if (res.state == 1) {
            _this.setTabValuesByFloorTabType(tab, res.data, firstTab);
          }

        })
    },
    //获取楼层左侧右键勾选的流程、流程块、商圈
    getLeftCircleSelectValues (item = {}) {
      const _this = this;
      return this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getFloorLeftFlowAndCircle.json", {
          // appId:_this.blockData.appId,
          appId: _this.getQuery('appId'),
          flowId: _this.blockData.id,
          navType: 'floor-left-prioroty',
          clickFlowId: item.id ? item.id : ''
        })
    },
    //通过 上下左右映射 ajax types的值
    getMapValuesByFloorTabType (floorTabShow = 'up') {
      var type = 'flow-nav-prioroty';
      switch (floorTabShow) {
        case 'center':
          type = 'floor-center-prioroty';
          break;
        case 'up':
          type = 'flow-nav-prioroty';
          break;
        case 'left':
          type = 'floor-left-prioroty';
          break;
        case 'right':
          type = 'floor-right-prioroty';
          break;
        case 'down':
          type = 'floor-bottom-prioroty';
          break;
        default:
          type = 'flow-nav-prioroty';
      }
      return type;
    },
    //通过上下左右 设置对应的tab勾选数据
    setTabValuesByFloorTabType (floorTabShow, list = [], first) {
      var _this = this;
      const tabItemParam = { refesh: false, activeTab: 0, tabType: first };
      switch (floorTabShow) {
        case 'center':
          if (first == 'center') {
            this.blockCenterList = list.length ? list : this.blockData.dataArr;
            // this.tabActiveType = 'center';
            if (first == 'center' && list.length == 0) {
              this.changeFlowTab(this.blockData.dataArr[0], tabItemParam);
            }
            this.swiperFn();
          }
          break;
        case 'up':
          // ---------
          // this.preTabListTop = list;
          // this.nodeNavTop = list;
          // ---------
          if (list.length) {
            list.forEach((ite) => {
              ite.tabType = 'check';
            })
          }
          if (this.blockData.flowSlideshow == 'on') {
            this.nodeNavTop = [...list, ...this.blockData.dataArr];
            this.preTabListTop = [...list, ...this.blockData.dataArr];
          } else {
            this.nodeNavTop = list;
            this.preTabListTop = list;
          }
          // if(first=='up'){
          //     this.changeFlowTab(this.nodeNavTop[0],tabItemParam);
          // }
          break;
        case 'left':
          // this.preTabListLeft = list;
          // this.nodeNavLeft = list;
          var leftRes = this.getLeftCircleSelectValues();
          _this.preTabListLeft = [];
          _this.nodeNavLeft = [];
          leftRes.then(res => {
            if (res.state == 1) {
              _this.isQuote = true;
              if (res.data.childFlowArr) {
                _this.nodeNavLeft.unshift(...res.data.childFlowArr);
                _this.preTabListLeft.unshift(...res.data.childFlowArr);
              }

              if (res.data.circleArr) {
                _this.nodeNavLeft.unshift(...res.data.circleArr);
                _this.preTabListLeft.unshift(...res.data.circleArr);
              }

            } else {
              _this.preTabListLeft = list;
              _this.nodeNavLeft = list;
            }
          })
          if (first == 'left') {
            this.changeFlowTab(list[0], tabItemParam);
          }
          break;
        case 'right':
          this.preTabListRight = list;
          this.nodeNavRight = list;
          if (first == 'right') {
            this.changeFlowTab(list[0], tabItemParam);
          }
          break;
        case 'down':
          this.preTabListBottom = list;
          this.nodeNavDown = list;
          if (first == 'down') {
            this.changeFlowTab(list[0], tabItemParam);
          }
          break;
        default:
        // this.preTabList = list;
        // this.changeFlowTab(this.blockData.dataArr[0],tabItemParam);
      }
      //楼层左侧商圈选择
      // this.$blockGetData.handleCircleChoose(this.blockData.id).then(res=>{
      //     if(res.state == "1"){
      //         _this.nodeNavLeft = this.$blockGetData.initGroupCircle(res.data);
      //         _this.preTabListLeft = this.$blockGetData.initGroupCircle(res.data);
      //         _this.circleTabList = res.data;
      //         _this.candliverProp = false;
      //     }else{
      //         _this.candliverProp = true;
      //     }
      // });
    },
    handleDetail (ite) {
      sessionStorage.setItem('floorDetailShow', this.floorDetailShow)
      var blockId = this.blockId;
      var contentId = ite.contentId ? ite.contentId : this.contentId;
      sessionStorage.setItem('originName', JSON.stringify({ blockId: blockId, contentId: contentId }));
      this.$store.commit('setPreItem', this.nodeNavTop[0]);
      this.$blockGetData.handleDetail(this, ite);
    },
    //标签取值方法
    getStandardData (nameArr, type, nameData, allTagsStandArr) {
      const sNames = (typeof nameArr == 'string') ? [nameArr] : nameArr;

      var filterStandArr = allTagsStandArr.filter((ite) => sNames.indexOf(ite.standardName) > -1);

      var filterData = filterStandArr[0] ? filterStandArr[0].standardData : nameData;

      var message = '';
      var requiredMsg = '';

      switch (type) {
        case 'required':
          if (!filterData) {
            requiredMsg = `${sNames[0]}`;
          }
          break;
        case 'number':
          if (isNaN(filterData)) {
            message = `${sNames[0]}`;
          }
          break;
      }

      if (requiredMsg) {
        this.requiredMsgs.push(requiredMsg);
      }
      if (message) {
        this.messages.push(message);
      }
      return filterData;
    },
    //加入购物车 所需参数拼接
    joinShopCart (detail) {
      this.messages = [];
      this.requiredMsgs = [];

      const allTagsStands = [...detail.pictures, ...detail.others, ...detail.btns];
      var chanpinmingchen = this.getStandardData('产品名称', 'required', '', allTagsStands);
      // this.getStandardData('产品标识','required','',allTagsStands);
      var danjia = this.getStandardData(['单价', '基础价格', '价格', '基准价', '金额'], 'number', '', allTagsStands);
      var shuliang = this.getStandardData('数量', 'number', '1', allTagsStands);
      var banbenhao = this.getStandardData('版本号', '', 'C1.0', allTagsStands);
      var pingtaiid = window.$pfId ? window.$pfId : ""
      var userId = this.$store.state.userInfo.userId
      var chanpintupian = detail.pictures.length ? detail.pictures[0] : require('../../assets/image/images/default_media.png');
      // if (!userId) {
      //   this.$notify({
      //     title: '提示',
      //     message: '请先登录',
      //     type: 'warning',
      //   });
      //   return;
      // }

      if (this.requiredMsgs.length > 0) {
        this.$notify({
          title: '提示',
          message: `${this.requiredMsgs.join('、')}为必填选项，请去补充标签，并生成，再进行此操作`,
          type: 'warning',
          duration: 10000
        });
        return;
      }

      if (this.messages.length > 0) {
        this.$notify({
          title: '提示',
          message: `${this.messages.join('、')}，的值不是数字类型，请输入阿拉伯数字`,
          type: 'warning',
          duration: 10000
        });
        return;
      }

      return [{
        appName: chanpinmingchen,
        sceneId: window.$sceneId ? window.$sceneId : "",
        appPicture: chanpintupian,
        appId: this.title,
        unitPrice: danjia,
        counts: shuliang,
        moneys: danjia * shuliang,
        appVersion: banbenhao,
        userId: userId,
        pfId: pingtaiid
      }];
    },
    optionClick (btn, item) {
      if (btn.rightButtonUrl) {
        if (btn.standardName == '加入购物车') {
          this.$http
            .post(btn.rightButtonUrl,
              { arrs: JSON.stringify(this.joinShopCart(item)) })
            .then(res => {
              if (res.state == 1) {
                this.$notify({
                  title: '提示',
                  message: '加入购物车成功，请点击顶部导航购物车列表进行购买！',
                  type: 'success'
                })
              }
            });
        }
      } else {
        if (btn.standardData) {
          btn.standardData ? this.open(btn.standardData, '_blank') : false
          return;
        }
        this.$notify({
          title: '提示',
          message: '右键工具标签未选择对应右键接口，请先去补充！',
          type: 'warning'
        })
      }
    },
    setDefaultTags () {
      let _this = this;
      var perNum = window.innerWidth <= 768 && window.innerWidth > 425 ? 2 : 8;
      for (var i = 0; i < perNum; i++) {
        _this.listData.push({
          id: '',
          pictures: [require('../../assets/image/images/default_media.png')],
          others: [{ standardData: '标签' }, { standardData: '描述' }],
          tags: [{ standardName: '', standardData: '' }]
        })
      }
      _this.flowStep = 4;
    },
    getProduct (pDataArr = []) {
      const _this = this;
      if (pDataArr.length == 0) {
        _this.setDefaultTags();
      } else {
        pDataArr.forEach((pData, index) => {
          var pictures = [];
          var others = [];
          var btns = [];
          var rests = [];
          if (!pData || !pData.standardJson) {
            _this.setDefaultTags();
            return false;
          } else {
            pData.standardJson.forEach((ele) => {
              // if(ele.isShow!='0'){
              if (ele && ele.standardType == 0 && ele.standardData && (ele.standardData.indexOf('.mp4') > 0 || ele.standardData.indexOf('.png') > 0 || ele.standardData.indexOf('.jpg') > 0 || ele.standardData.indexOf('.jpeg') > 0)) {
                pictures.push(ele.standardData);
              } else if (ele.standardType == 0) {
                others.push(ele);
              } else if (ele.standardType == 3) {
                btns.push(ele);
              } else {
                rests.push(ele);
              }
              // }
            });
            this.showList = this.showList == false ? true : true;
          }
          _this.flowStep = 4;
          _this.contentId = pData.contentId;
          _this.listData.push({
            id: pData.contentId,
            contentShowRowsSort: pData.contentShowRowsSort,
            sceneId: pData.sceneId,
            contentId: pData.contentId,
            sceneGroupId: pData.sceneGroupId,
            pictures: pictures,
            others: [...others, ...rests],
            btns: btns,
            tags: [...others, ...rests],
            nodeId: pData.nodeId,
            ind: index
          })
        })

      }
      _this.swiperFn()
    },
    //通过流程请求下级
    getFlowOrBlockByFlowId (item, param) {
      this.flowId = item.id;
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowFloorDataSpit.json", {
          // appId:this.blockData.appId,
          appId: this.getQuery('appId'),
          flowId: item.id,
          sceneGroupId: '',
          diyPageFlowId: '',
          domainNameType: document.location.pathname.split('/')[1]
        }).then(res => {
          if (res.state == 1) {
            this.centerStyle = res.data[0].floorStyle ? res.data[0].floorStyle : this.blockData.floorType;
            if (this.centerStyle == 'flowArchShow') {
              this.floorTabShow = [];
              this.$refs.rightContent.style.border = 0;
            } else {
              this.$refs.rightContent.style.border = '1px solid #ddd';
            }
            if (this.centerStyle == 'banner') {
              this.centers = 'banner';
            }
            this.handleTabDataAll(item, param, res.data)
          }
        })
    },
    //tab切换数据处理
    handleTabDataAll (item, param, resData) {
      const _this = this;
      if (resData && resData[0].dataArr && resData[0].dataArr.length > 0) {

        if (item.flowType == "flow") {
          _this.leftTabInd = 0;
          if (param.tabType == 'up' && param.refesh) {
            _this.nodeNavTop = resData[0].dataArr;
            _this.nodeNavTop.unshift(item);
          }
          //中间点击
          if (param.tabType == 'center' && param.refesh) {
            _this.blockCenterList = resData[0].dataArr;
            _this.blockCenterList.unshift(item);
          }
          //左侧tab点击
          if (param.tabType == 'left' && param.refesh) {
            // _this.nodeNavLeft = resData[0].dataArr
            // _this.nodeNavLeft.unshift(item);
            if (_this.isQuote) {
              var leftRes = _this.getLeftCircleSelectValues(item);
              leftRes.then(res => {
                if (res.state == 1) {
                  _this.isQuote = true;
                  _this.nodeNavLeft = [];
                  if (res.data.circleArr) {
                    _this.nodeNavLeft.push(...res.data.circleArr);
                  }
                  if (res.data.childFlowArr) {
                    _this.nodeNavLeft.push(...res.data.childFlowArr);
                  }
                  _this.nodeNavLeft.unshift(item);
                } else {
                  _this.nodeNavLeft = resData[0].dataArr;
                  _this.nodeNavLeft.unshift(item);
                }
              })
            } else {
              _this.nodeNavLeft = resData[0].dataArr
              _this.nodeNavLeft.unshift(item);
            }
          }
          //右侧tab点击
          if (param.tabType == 'right' && param.refesh) {
            _this.nodeNavRight = resData[0].dataArr
            _this.nodeNavRight.unshift(item);
          }
          //下侧tab点击
          if (param.tabType == 'down' && param.refesh) {
            _this.nodeNavDown = resData[0].dataArr
            _this.nodeNavDown.unshift(item);
          }
          //解决流程点击不显示默认图片问题
          // _this.handleMore(item);
          _this.swiperFn();
        }
      } else {
        _this.setDefaultTags()
      }
    },
    //通过流程获取标签
    getTagsByFlowId (fId, pageNum = 1) {
      // if(pageNum>2){
      //     return false;
      // }
      const _this = this;
      this.$http.get("/zciid-deliverable/showPlatformStyle/flow/api/getContentDataByflowId.json", {
        // appId:_this.blockData.appId,
        appId: _this.getQuery('appId'),
        flowId: fId,
        pageNum: pageNum
      }).then((res) => {
        if (res.state == 1) {
          _this.getProduct(res.data);
          _this.standardListJson.push(...res.data);
          if (res.data.length == 10) {
            _this.getTagsByFlowId(fId, pageNum + 1);
          }
          if (_this.centerStyle == 'banner') {
            _this.centers = 'banner';
          }
        } else {
          if (pageNum == 1) {
            _this.getProduct();
          } else {
            _this.flowStep = 4
          }
        }
      })
    },
    //通过流程块请求标签（非左侧组织架构）
    getTagsByBlockId (item, param) {
      const _this = this;
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getContentDataByBlockNodeId.json", {
          appId: _this.getQuery('appId'),
          blockId: item.id,
          nodeId: item.nodeId
        }).then(res => {
          if (res.state == 1) {
            if (res.data[0].floorStyle) {
              _this.centerStyle = res.data[0].floorStyle;
              if (res.data[0].floorStyle == 'flowArchShow') {
                _this.floorTabShow = [];
                this.$refs.rightContent.style.border = 0;
              } else {
                this.$refs.rightContent.style.border = '1px solid #ddd';
              }
            } else if (param.refesh) {
              _this.centerStyle = _this.centerStyles;
              if (_this.centerStyles == 'flowArchShow') {
                _this.floorTabShow = [];
                this.$refs.rightContent.style.border = 0;
              } else {
                this.$refs.rightContent.style.border = '1px solid #ddd';
              }
            };
            if (this.centerStyle == 'banner') {
              this.centers = 'banner';
            }
            _this.listData = []
            _this.getProduct(res.data)
            _this.flowStep = 4
            res.data.forEach(ite => {
              ite.nodeId = item.nodeId
            })
            _this.standardListJson = res.data;
            _this.swiperFn();

          }
        })
    },
    //左侧流程块 引用点击请求（引用流程数据）
    getFlowByBlockId (item) {
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getQuoteFlowByBlockId.json", {
          // appId:this.blockData.appId,
          appId: this.getQuery('appId'),
          blockId: item.id
        }).then(res => {
          if (res.state == 1) {
            this.nodeNavTop = [res.data]
            if (this.centerStyle == 'banner') {
              this.centers = 'banner';
            }
          }
        })
    },
    changeFlowTab (item, param) {
      this.changeFlowBlock = item.flowType;
      if (!item) { return false }
      this.iframeSrc = '';
      if (item.pageUrl && item.pageUrl != 'javascript:;') {
        // this.open(item.pageUrl, "_blank");
        window.location.assign(item.pageUrl)
        return false;
      }
      this.swiperInd = item.id ? item.id : '';
      this.tabActiveType = param.tabType;
      const _this = this;
      this.nodeId = '';
      this.standardListJson = [];
      clearInterval(this.timer);
      if (item.flowType == "flow") {
        this.flowId = item.id;
        this.listData = []
        this.getFlowOrBlockByFlowId(item, param);
        this.getTagsByFlowId(item.id, 1);

      } else if (item.flowType == "block") {
        _this.leftTabInd = param.activeTab;
        _this.blockId = item.id;
        _this.nodeId = item.nodeId;
        // this.$http
        // .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getContentDataByBlockNodeId.json", {
        //     appId:this.getQuery('appId'),
        //     sceneId:this.$route.query.sceneId,
        //     blockId:item.id,
        //     nodeId:item.nodeId,
        //     sceneGroupId:this.$route.query.sceneGroupId,
        // }).then(res => {
        //     if(res.state==1){
        //         this.getProduct(res.data)
        //         _this.standardListJson = res.data;
        //     }
        // }) 
        if (item.hasQuote == 'isQuote') {
          this.getFlowByBlockId(item);
        }
        this.getTagsByBlockId(item, param);
      }
      // else if(item.flowType=="circle"){
      //     let filterList = this.circleTabList.filter((ele)=>ele.types==item.types);
      //     _this.nodeNavLeft = filterList;
      //     _this.preTabListLeft = filterList;
      // }
    },
    //刷新数据
    refeshData () {
      this.flowNewList = [];
      this.listData = [];
      this.tabActiveType = 'up'
      this.flowStep = 0
      this.leftTabInd = 0
      this.$backArr = [];
      var { id } = this.blockData;
      this.getTabBlock(id);
      var tablist = this.$blockGetData.getActiveType(this.floorTabShow)
      tablist.map((tab) => {
        this.getSelectTabFlowAndBlock(id, tab, tablist[0]);
      })
      this.rightSrc = '';
    }
  }
}
</script>
<style lang="scss" scoped>
#knowledge62 .outreach_content .block-content .right-content {
  border: 1px solid#ddd;
}
#knowledge62
  .outreach_content
  .block-content
  .right-content
  .content-center
  .bottom-switch {
  padding: 18px;
  overflow: hidden;
}
#knowledge62
  .outreach_content
  .block-content
  .right-content
  .content-center
  .bottom-switch.knowledgeCenter.expert-alliance-box {
  height: 326px;
}
/*知识中心的css*/

/*具体内容开始*/
#knowledge62 .intel-top {
  overflow: hidden;
  margin-bottom: 10px;
}
#knowledge62 .intel-top .intel-top-left {
  width: 280px;
  height: 187px;
  margin-right: 20px;
  overflow: hidden;
}
#knowledge62 .intel-top .intel-top-left a img {
  width: 280px;
  height: 187px;
  transition: all 0.3s linear;
  -webkit-transition: all 0.3s linear;
  -moz-transition: all 0.3s linear;
  -o-transition: all 0.3s linear;
}
#knowledge62 .intel-top .intel-top-left img:hover {
  transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -o-transform: scale(1.1);
  -ms-transform: scale(1.1);
}
#knowledge62 .intel-top .intel-top-right {
  width: calc(100% - 300px);
  width: -moz-calc(100% - 300px);
  width: -webkit-calc(100% - 300px);
}
#knowledge62 .intel-top .intel-top-right .intel-title {
  font-size: 20px;
  color: #0d78cf;
  font-weight: 600;
  height: 42px;
  line-height: 42px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#knowledge62 .intel-top .intel-top-right .intel-price {
  font-size: 14px;
  color: #666;
  height: 26px;
  line-height: 26px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#knowledge62 .intel-top .intel-top-right .intel-det {
  font-size: 14px;
  color: #666;
  height: 73px;
  line-height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  word-wrap: break-word;
}
#knowledge62 .intel-top .intel-top-right .intel-btn {
  margin-top: 10px;
  display: inline-block;
}
#knowledge62 .intel-top .intel-top-right .intel-btn .btn-more {
  display: block;
  height: 36px;
  line-height: 36px;
  padding: 0 25px;
  font-size: 14px;
  color: #fff;
  border-radius: 3px;
  margin-right: 10px;
}
#knowledge62 .intel-top .intel-top-right .intel-btn .btn-more.blue {
  background: #2f8eed;
}
#knowledge62 .intel-top .intel-top-right .intel-btn .btn-more.green {
  background: #12bca6;
}
#knowledge62 .intel-top .intel-top-right .intel-btn .btn-more:hover {
  filter: brightness(1.1);
  -webkit-filter: brightness(1.1);
}

/* 企业简介 banner样式 */
#knowledge62.companyIntroduce .intel-bot {
  display: none;
}
#knowledge62.companyIntroduce .intel-top {
  height: 443px;
  overflow: visible;
}
#knowledge62.companyIntroduce .intel-top .intel-top-left {
  height: 443px;
  width: calc(50% - 20px);
}
#knowledge62.companyIntroduce .intel-top .intel-top-left a img {
  width: 100%;
  height: 443px;
  display: block;
}
#knowledge62.companyIntroduce .intel-top .intel-top-right {
  width: 50%;
  height: 443px;
}
#knowledge62.banner .intel-bot {
  display: none;
}
#knowledge62.banner .intel-top {
  height: 443px;
  overflow: visible;
}
#knowledge62.banner .intel-top .intel-top-left {
  height: 443px;
  width: 100%;
}
#knowledge62.banner .intel-top .intel-top-left a img {
  width: 100%;
  height: 443px;
  display: block;
}
#knowledge62.banner .intel-top .intel-top-right {
  display: none;
}

// #knowledge62 .intel-bot{}
#knowledge62 .intel-bot ul {
  width: 100%;
  overflow: hidden;
}
#knowledge62 .intel-bot ul li {
  margin-top: 10px;
  margin-left: 14px;
  width: 144px;
  height: 212px;
  border: 1px solid #ddd;
  overflow: hidden;
  float: left;
}
#knowledge62 .intel-bot ul li:nth-of-type(2) {
  margin-left: 0;
}
#knowledge62 .intel-bot ul li a {
  display: block;
}
#knowledge62 .intel-bot ul li a.text {
  line-height: 180px;
  height: 180px;
  font-size: 0;
  text-align: center;
  display: block;
}
#knowledge62 .intel-bot ul li .intel-bot-tit a {
  padding: 0 16px;
  overflow: hidden;
  text-overflow: ellipsis;
}
#knowledge62 .intel-bot ul li:hover a img {
  transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -o-transform: scale(1.1);
  -ms-transform: scale(1.1);
}
#knowledge62 .intel-bot ul li img {
  vertical-align: middle;
  width: 112px;
  height: 142px;
  transition: all 0.3s linear;
  -webkit-transition: all 0.3s linear;
  -moz-transition: all 0.3s linear;
  -o-transition: all 0.3s linear;
}
#knowledge62 .intel-bot ul li .intel-bot-tit {
  width: 100%;
  height: 30px;
  line-height: 30px;
  border-top: 1px solid #ddd;
  font-size: 16px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background: #fafafa;
  color: #333;
}
#knowledge62 .intel-bot ul li a > .z-image {
  /deep/ .el-image__inner {
    width: 100%;
    height: auto;
    vertical-align: middle;
  }
}
/*具体内容结束*/

/* 超小屏幕（手机，小于 768px） */
// @media screen and (min-width:426px) and (max-width: 767px) {
//     #knowledge62 .outreach_content .block-content .right-content .content-center .bottom-switch{height:auto;}
//     #knowledge62 .intel-top .intel-top-right .intel-title{font-size:16px;}
//     #knowledge62 .intel-bot ul li .intel-bot-tit{font-size:12px;height:30px;line-height:30px;}
//     #knowledge62 .intel-top .intel-top-right .intel-price{font-size:12px;margin-top:-10px;}
//     #knowledge62 .intel-top{margin-bottom:0;}
//     #knowledge62 .intel-top .intel-top-left,#knowledge62 .intel-top .intel-top-left a img,
//     #knowledge62 .intel-top .intel-top-right,#knowledge62 .intel-bot ul li img{width:100%;}
//     #knowledge62 .intel-bot ul li{width: calc(50% - 7px);width:-webkit-calc(50% - 7px);margin-left:0px;margin-top:10px;}
//     #knowledge62 .intel-bot ul li:nth-of-type(odd){margin-left:10px;}
//     #knowledge62 .intel-bot ul li a.text{line-height: unset;}
//     #knowledge62 .intel-bot ul li{height: unset;}
//     #knowledge62 .intel-bot ul li a>.z-image{
//         line-height: 180px;
//     }
//     .content-left-box,.content-right-box{width: 150px;position:absolute;top:0px;bottom:0px;z-index:9;background:#fff;border-left: 1px solid #dddddd;border-right: 1px solid #dddddd;height:auto;}
//     .content-left-box{left:0;}
//     .content-right-box{right:-1px;}
//     .block-content{position: relative;}
//     .btn-left,.btn-right{position: absolute;top:160px; width:30px;height:30px; border-radius:20px;z-index:8;background-size: contain;}
//     .btn-left{left:2px;background-image: url("~@/assets/image/images/icons/arrow_right_circular.png");  }
//     .btn-right{right:2px; background-image: url("~@/assets/image/images/icons/arrow_left_circular.png");}
//     .close-left,.close-right{position: absolute;top:10px; width:20px;height:20px; border-radius:10px;z-index:10;background-size: contain;background-image: url("~@/assets/image/images/icons/close_right_top.png")}
//     .close-left{left:120px;}
//     .close-right{right:120px;}
// }
// /* 超小屏幕（手机，小于 768px） */
// @media (min-width: 768px) and (max-width: 1200px) {
//     #knowledge62 .outreach_content .block-content .right-content .content-center .bottom-switch{height:auto;}
//     #knowledge62 .intel-bot ul li{width: calc(25% - 12px);width:-webkit-calc(25% - 12px);}
//     #knowledge62 .intel-bot ul li{margin:5px!important;}
//     // #knowledge62 .intel-bot ul li:nth-child(5n){margin-left:0;}
// }
</style>



// WEBPACK FOOTER //
// src/components/floorBlock/zszx.vue